import { cn } from '@/lib/cn'

/**
 * Storefront section heading in the hero's display voice - eyebrow, bold
 * uppercase Archivo title, muted subtitle. Keeps the marketplace sections
 * speaking with one typographic voice.
 */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  className,
}: {
  eyebrow?: string
  title: string
  subtitle?: string
  align?: 'left' | 'center'
  className?: string
}) {
  return (
    <div className={cn(align === 'center' && 'text-center', className)}>
      {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">{eyebrow}</p>}
      <h2
        className={cn(
          'text-2xl font-extrabold uppercase leading-tight tracking-[-0.02em] sm:text-3xl',
          eyebrow && 'mt-2',
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={cn('mt-2 text-sm text-foreground/60', align === 'center' && 'mx-auto max-w-2xl')}>{subtitle}</p>
      )}
    </div>
  )
}
